<template>
  <b-card>
    <base-overlay :show="fetchingReward">
      <validation-observer ref="rewardsFormRef">
        <b-form @submit.prevent="submitHandler">
          <b-row>
            <b-col md="4">
              <validation-provider
                name="Name En"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Name En"
                  label-for="name-en"
                >
                  <b-form-input
                    id="name-en"
                    v-model="rewardForm.name.en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <validation-provider
                name="Name Ar"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Name Ar"
                  label-for="name-ar"
                >
                  <b-form-input
                    id="name-ar"
                    v-model="rewardForm.name.ar"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="4">
              <b-form-group
                label="Amount"
                label-for="reward-amount"
              >
                <b-form-input
                  id="reward-amount"
                  v-model.number="rewardForm.amount"
                  type="number"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <validation-provider
                name="Effective Date"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Effective Date"
                  label-for="effective-date"
                >
                  <flat-pickr
                    id="effective-date"
                    v-model="rewardForm.effectiveTime"
                    class="form-control"
                    :config="{
                      enableTime: true,
                      minDate: new Date(),
                      allowInvalidPreload: true,
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="3">
              <validation-provider
                name="Expiry Date"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Expiry Date"
                  label-for="end-date"
                >
                  <flat-pickr
                    id="end-date"
                    v-model="rewardForm.endTime"
                    class="form-control"
                    :config="{
                      enableTime: true,
                      minDate: new Date(),
                      allowInvalidPreload: true,
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="Group"
                label-for="groups"
              >
                <v-select
                  id="groups"
                  v-model="rewardForm.group"
                  :options="groupsList"
                  :loading="fetchingGroups"
                  label="name"
                  :reduce="val => val.id"
                  @search="fetchGroups"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="Targeted Group"
                label-for="targeted-groups"
              >
                <v-select
                  id="targeted-groups"
                  v-model="rewardForm.targetedGroup"
                  :options="groupsList"
                  :loading="fetchingGroups"
                  label="name"
                  :reduce="val => val.id"
                  @search="fetchGroups"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <validation-provider
                name="Number of trips"
                rules="required|max-value:500"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Number of trips"
                  label-for="no-of-trips"
                >
                  <b-form-input
                    id="no-of-trips"
                    v-model.number="rewardForm.criteria.numberOfTrips"
                    type="number"
                    @input="numberOfTripsInput"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="Pickup Zone"
                label-for="pickup-zone"
              >
                <v-select
                  id="pickup-zone"
                  v-model="rewardForm.criteria.pickupZone"
                  :options="zonesList"
                  :loading="fetchingZones"
                  :disabled="fetchingZones"
                  label="name"
                  multiple
                  :reduce="val => val.zone_id"
                />
              </b-form-group>
            </b-col>
            <b-col md="9">
              <b-form-group
                label="Role"
              >
                <b-form-radio-group
                  v-model="rewardForm.criteria.role"
                  value-field="value"
                  text-field="label"
                  :options="roleOptions"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <validation-provider
                name="English reward description"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="English reward description"
                  label-for="en-reward-description"
                >
                  <b-form-textarea
                    id="en-reward-description"
                    v-model="rewardForm.description.en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                name="Arabic reward description"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Arabic reward description"
                  label-for="ar-reward-description"
                >
                  <b-form-textarea
                    id="ar-reward-description"
                    v-model="rewardForm.description.ar"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                name="English reward details"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="English reward details"
                  label-for="en-reward-details"
                >
                  <b-form-textarea
                    id="en-reward-details"
                    v-model="rewardForm.details.en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                name="Arabic reward details"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Arabic reward details"
                  label-for="ar-reward-details"
                >
                  <b-form-textarea
                    id="ar-reward-details"
                    v-model="rewardForm.details.ar"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="English reward note"
                label-for="en-reward-note"
              >
                <b-form-textarea
                  id="en-reward-note"
                  v-model="rewardForm.note.en"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Arabic reward note"
                label-for="ar-reward-note"
              >
                <b-form-textarea
                  id="ar-reward-note"
                  v-model="rewardForm.note.ar"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <validation-provider
                name="English notification title"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="English notification title"
                  label-for="en-title"
                >
                  <b-form-input
                    id="en-title"
                    v-model="rewardForm.notification.title.en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                name="Arabic notification title"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Arabic notification title"
                  label-for="ar-title"
                >
                  <b-form-input
                    id="ar-title"
                    v-model="rewardForm.notification.title.ar"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                name="English notification description"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="English notification description"
                  label-for="en-description"
                >
                  <b-form-textarea
                    id="en-description"
                    v-model="rewardForm.notification.description.en"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <validation-provider
                name="Arabic notification description"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Arabic notification description"
                  label-for="ar-description"
                >
                  <b-form-textarea
                    id="ar-description"
                    v-model="rewardForm.notification.description.ar"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              md="12"
              class="mb-1"
            >
              <b-form-checkbox v-model="rewardForm.criteria.daily">
                Daily
              </b-form-checkbox>
            </b-col>
            <b-col :md="rewardForm.criteria.daily ? 6 : 4">
              <validation-provider
                :name="rewardForm.criteria.daily ? 'From hour' : 'From date'"
                :rules="`required${rewardForm.criteria.daily ? '|between:0,23' : ''}`"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  :label="rewardForm.criteria.daily ? 'From hour' : 'From date'"
                  label-for="from"
                >
                  <template
                    v-if="rewardForm.criteria.daily"
                  >
                    <b-form-input
                      id="from"
                      v-model.number="rewardForm.criteria.fromHour"
                      type="number"
                    />
                    <b-form-text>24 hour format, 0 to 23</b-form-text>
                  </template>
                  <b-form-datepicker
                    v-else
                    v-model="rewardForm.effectiveTime"
                    disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col :md="rewardForm.criteria.daily ? 6 : 4">
              <validation-provider
                :name="rewardForm.criteria.daily ? 'To hour' : 'To date'"
                :rules="`required${rewardForm.criteria.daily ? '|between:0,24' : ''}`"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  :label="rewardForm.criteria.daily ? 'To hour' : 'To date'"
                  label-for="to"
                >
                  <template
                    v-if="rewardForm.criteria.daily"
                  >
                    <b-form-input
                      id="to"
                      v-model.number="rewardForm.criteria.toHour"
                      type="number"
                    />
                    <b-form-text>24 hour format, 0 to 24</b-form-text>
                  </template>
                  <b-form-datepicker
                    v-else
                    v-model="rewardForm.endTime"
                    disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="!rewardForm.criteria.daily"
              md="4"
            >
              <validation-provider
                name="Expire At"
                rules="required"
              >
                <b-form-group
                  slot-scope="{ errors }"
                  label="Expire At"
                  label-for="expire-at"
                >
                  <flat-pickr
                    id="expire-at"
                    v-model="rewardForm.expireAt"
                    class="form-control"
                    :config="{
                      enableTime: true,
                      minDate: new Date(),
                      allowInvalidPreload: true,
                    }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-button
            variant="primary"
            type="submit"
            :disabled="submitting"
          >
            <b-spinner
              v-if="submitting"
              small
            />
            <span v-else>Submit</span>
          </b-button>
        </b-form>
      </validation-observer></base-overlay>
  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, maxValue } from '@validations'

import {
  BForm, BRow, BCol, BCard, BFormGroup, BFormInput, BFormDatepicker, BFormTextarea, BFormCheckbox, BFormText, BButton, BSpinner, BFormRadioGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import useRewardForm from '../hooks/useRewardForm'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import store from '../store'
import groupsStore from '@/views/marketing/groups/store'
import zonesStore from '@/views/zones/zoneStoreModule'

export default {
  components: {
    BForm,
    BRow,
    BCol,
    BCard,
    ValidationObserver,
    BButton,
    vSelect,
    ValidationProvider,
    flatPickr,
    BFormGroup,
    BFormRadioGroup,
    BFormText,
    BFormCheckbox,
    BFormDatepicker,
    BSpinner,
    BFormInput,
    BFormTextarea,
  },
  props: {
    isNew: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    useRegisterStoreModule('rewards', store)
    useRegisterStoreModule('groups', groupsStore)
    useRegisterStoreModule('zones', zonesStore)

    return {
      ...useRewardForm(props, ctx),
      required,
      maxValue,
    }
  },
}
</script>

<style>

</style>
